import { render, staticRenderFns } from "./crudcampomr.vue?vue&type=template&id=06b3ae42&scoped=true"
import script from "./crudcampomr.vue?vue&type=script&lang=js"
export * from "./crudcampomr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b3ae42",
  null
  
)

export default component.exports